import { Inbox } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, sub }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      <div className="h-12 w-12 rounded-xl bg-slate-100 flex items-center justify-center mb-3">
        <Icon className="h-6 w-6 text-slate-400" strokeWidth={1.5} />
      </div>
      <div className="font-display font-semibold text-slate-700">{title}</div>
      {sub && <div className="text-sm text-slate-400 mt-1 max-w-xs">{sub}</div>}
    </div>
  );
}
